export default {
  title: 'Material Space',
  fileUsage: 'File Count',
  allMaterials: 'All Materials',
  images: 'Images',
  videos: 'Videos',
  selectAll: 'Select All',
  newFolder: 'New Folder',
  localUpload: 'Upload',
  addFolder: '+New Folder',
  referenced: 'Referenced',
  delete: 'Delete',
  productMainImage: 'Product Images',
  newFolderTitle: 'New Folder',
  parentFolder: 'Parent Folder',
  pleaseSelect: 'Please select',
  folderName: 'Folder Name',
  folderNamePlaceholder: 'Enter folder name',
  confirm: 'OK',
  cancel: 'Cancel',
  uploadTitle: 'Upload Image/Video',
  selectFile: 'Select File',
  uploadPreview: 'Upload Preview',
  selectFolder: 'Select Folder',
  closeGallery: 'Close Gallery',
  useSelectedImages: 'Use Selected Images',
  useSelectedVideos: 'Use Selected Videos',
  deleteConfirm: 'Are you sure you want to delete the selected files?',
  deleteSuccess: 'Deleted successfully',
  deleteFailed: 'Delete failed',
  createFolderSuccess: 'Folder created successfully',
  createFolderFailed: 'Failed to create folder',
  folderNameRequired: 'Please enter a folder name',
  noFileSelected: 'Please select a file',
  uploadSuccess: 'Upload successful',
  uploadFailed: 'Upload failed',
  renameFolder: 'Rename',
  deleteFolder: 'Delete Folder',
  renameFolderTitle: 'Rename Folder',
  newFolderNameLabel: 'New Name',
  newFolderNamePlaceholder: 'Enter new folder name',
  renameFolderSuccess: 'Renamed successfully',
  renameFolderFailed: 'Rename failed',
  deleteFolderConfirm: 'Are you sure you want to delete this folder? Files inside will be moved to the default directory.',
  deleteFolderSuccess: 'Folder deleted successfully',
  deleteFolderFailed: 'Failed to delete folder',
  preview: 'Preview',
  deleteFileConfirm: 'Are you sure you want to delete this file?',
  deleteFileSuccess: 'File deleted successfully',
  deleteFileFailed: 'Failed to delete file',
  uploadFormatNotSupported: 'Unsupported format: {names}. Only JPG / PNG / JPEG are allowed',
  uploadBatchLimitExceeded: 'Up to {max} files per batch. Please upload in batches',
  uploadAllowedFormatsTip: 'Only JPG / PNG / JPEG, up to {max} files per upload',
  uploadFormatNotSupportedSimple: 'Unsupported format. Only JPG / PNG / JPEG are allowed',
  selectionLimitReached: 'Up to {max} images can be selected',
  selectedCount: 'Selected {n} / {max}',
  referencedItemNotSelectable: 'This item is referenced and cannot be selected',
  loadingMore: 'Loading…',
  noMore: 'All {n} items loaded',
  shownProgress: 'Shown {shown} / {total}',
  pickerImageDialogTitle: 'Select Image',
  pickerVideoDialogTitle: 'Select Video'
}
